export default __webpack_public_path__ + "static/media/Vaani_Research_Station.fbf6ce75.jpg";